import React, { useState } from "react";

import styled from "styled-components";

import Alert from "components/atoms/alert/Alert";
import useLoading from "components/atoms/loading/useLoading";
import GeneralText from "components/atoms/text/GeneralText";

import InputWithLabel from "components/molecules/InputWithLabel";
import AbstractModalFooter from "components/page/modal/AbstractModalFooter";

import { apiUrl } from "utils/urls";

import axios from "axios";

const Container = styled.div`
    width: 100%;
`;

function ReferenceAddDoiModal(props) {
    const [doi, setDoi] = useState("");
    const { setLoading } = useLoading();

    const handleAddButton = () => {
        setLoading(true, "참고문헌 정보를 확인 중입니다.");
        axios
            .post(apiUrl("paperMetadata"), {
                reference_id: doi,
                reference_source: "doi",
            })
            .then((res) => {
                setLoading(false);
                props.mutation.mutate({
                    body: {
                        display_name: res.data.display_name,
                        bib_json: res.data.bib_json,
                    },
                });
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
                Alert("warn", "에러", "참고문헌 추가 중 오류가 발생했습니다.");
            });
    };

    return (
        <Container>
            <GeneralText size={"regular"}>참고문헌 추가를 위해 DOI를 입력해주세요.</GeneralText>
            {/* DOI로 참고문헌 추가 기능 */}
            <InputWithLabel
                width="100%"
                margin="24px 0 0 0"
                labelText="DOI"
                essenMarkDp="none"
                bgColor="var(--color-Base1)"
                infoTextDp="block"
                infoText="DOI"
                tooltipDp="flex"
                tooltipMessage="DOI(Digital Object Identifier)는 디지털 콘텐츠를 고유하게 식별하는 데 사용되는 표준 정보 식별자입니다."
                placeholder="EX) 10.1038/nature16961"
                onChange={(e) => setDoi(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleAddButton();
                    }
                }}
                value={doi}
            />
            <AbstractModalFooter
                leftBtnText={"취소"}
                rightBtnText={"추가"}
                leftOnClick={props.exitModal}
                rightOnClick={handleAddButton}
                disabled={!doi}
            />
        </Container>
    );
}

export default ReferenceAddDoiModal;
